import { render } from "./AccountConfirm.vue?vue&type=template&id=406818f5"
import script from "./AccountConfirm.vue?vue&type=script&lang=js"
export * from "./AccountConfirm.vue?vue&type=script&lang=js"

import "./AccountConfirm.vue?vue&type=style&index=0&id=406818f5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__